import { Component, OnInit, OnDestroy } from '@angular/core';
import { PwaInstallService } from '../service/pwa-install-banner.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pwa-install-banner',
  templateUrl: './pwa-install-banner.component.html',
  styleUrl: './pwa-install-banner.component.css',
  standalone: false
})
export class PwaInstallBannerComponent implements OnInit, OnDestroy {
    showBanner = false;
    private sub: Subscription;

    constructor(private pwaInstallService: PwaInstallService) {}

    ngOnInit(): void {
        if (this.pwaInstallService.isBannerSuppressed()) return;

        this.sub = this.pwaInstallService.canInstall$.subscribe(canInstall => {
            this.showBanner = canInstall;
        });
    }

    install(): void {
        this.pwaInstallService.promptInstall();
    }

    dismiss(): void {
        this.showBanner = false;
        this.pwaInstallService.dismissBanner();
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }
}